
// frontend/src/socket.js
import { io } from 'socket.io-client';
import { SOCKET_URL } from './config';

let _socket = null;

export function getSocket() {
  if (!_socket) {
    const token = localStorage.getItem('token') || '';
    _socket = io(SOCKET_URL, {
      withCredentials: true,
      auth: token ? { token } : undefined,
    });
  }
  return _socket;
}

// Optional: falls du irgendwo bewusst disconnecten willst
export function disconnectSocket() {
  if (_socket) {
    _socket.disconnect();
    _socket = null;
  }
}

// Für maximale Kompatibilität: sowohl Default als auch Named Export anbieten
export default getSocket;
export { _socket as socket };

